import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";

export interface IMenuItem {
    avatarUrl: string;
    title: string;
    subtitle?: string;
    id?: string | number;
}

@Component({
    selector: "vui-menu-item",
    standalone: true,
    imports: [CommonModule, MatIconModule, MatCardModule],
    templateUrl: "./menu-item.component.html",
    styleUrl: "./menu-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent {
    @Input() item: IMenuItem;

    @Output() itemSelected = new EventEmitter<IMenuItem>();

    @Input() selected: boolean = false;

    handleClick() {
        this.itemSelected.emit(this.item);
    }
}
